import React from 'react'
import clsx from 'clsx'
import Head from 'next/head'
import Link from 'next/link'

import public_styles from '@/css/public.module.css'

const ErrorPage = () => {
  return (
    <div className={public_styles.container}>
      <Head>
        <title>Not found</title>
        <meta name='robots' content='noindex, nofollow' />
        <meta name='googlebot' content='noindex,nofollow' />
      </Head>
      <div className={clsx(public_styles.block, public_styles.mt_1, public_styles.align_center)}>
        <h1>Page not found</h1>
        <div className={clsx(public_styles.second_black, public_styles.error_page_description)}>
          The page you&apos;ve requested didn&apos;t exist
        </div>
        <div className={public_styles.mt_1}>
          <Link href={'/'} className={public_styles.button} title={'Go to homepage'}>
            Go to homepage
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
